<div class="flex items-stretch justify-between gap-12 children:w-1/2 children:flex-1 ">
  <app-card class="w-full">
    <div class="flex flex-col p-4 ">
      <div class="flex flex-col lg:flex-row justify-between">
        <div class="ballot-summary-title" id="ballot-summary">Ballot Summary</div>
        <div class="flex flex-col gap-4 justify-end">
          <app-ballot-status-badge class="mt-2" [statusId]="ballotStatusId">
          </app-ballot-status-badge>

          <app-ballot-review-stage-badge
            *ngIf="srsBallotDetail?.unifiedStatusId===unifiedBallotStatus.pendingFinalisedApproval && srsBallotDetail?.reviewStageDisplayText"
            [reviewStageId]="srsBallotDetail?.reviewStageId"
            [reviewStageDisplayText]="srsBallotDetail?.reviewStageDisplayText">
          </app-ballot-review-stage-badge>
        </div>
      </div>


      <div class="mt-8 text-grey-800">
        <div class="flex flex-col lg:flex-row">
          <div class="lg:w-1/2">
            <div id="div-published-date">
              <label class="ballot-summary-label" id="ballot-summary-published-date-label">Published Date</label>
              <p class="ballot-summary-value" id="ballot-summary-published-date-value">
                {{srsBallotDetail?.publicationCreateDate | date: 'dd/MM/yyyy'}}
              </p>
            </div>
            <div id="div-committee">
              <label class="ballot-summary-label" id="ballot-summary-committee-label">Committee</label>
              <a id="ballot-summary-committee-value" [routerLink]="['/committees', srsBallotDetail?.committee]"
                class="block overflow-hidden leading-6 whitespace-pre-wrap text-link text-ellipsis">
                <p>{{getCommitteeName()}}</p>
              </a>
            </div>

            <div id="div-ballot-project-manager">
              <label for="a-srs-ballot-project-manager">Lead</label>
              <p class="body-default-regular">
                <a
                  class="body-default-regular text-link"
                  id="a-srs-ballot-project-manager"
                  href="mailto:{{ srsBallotDetail?.projectManagerEmail }}"
                >
                  {{ srsBallotDetail?.projectManager }}
                </a>
              </p>
            </div>

            <div id="div-Associated-Documents">
              <label class="mb-2 ballot-summary-label" id="ballot-summary-associated-documents-label">Associated
                Documents</label>
              <a (click)="downloadDocument($event, designationURL)"
                class="block overflow-hidden leading-6 cursor-pointer text-link text-ellipsis whitespace-nowrap"
                id="ballot-summary-associated-documents-value">{{ designation }}</a>
              <div *ngFor="let doc of srsBallotDetail?.associatedDocuments">
                <a (click)="downloadDocument($event, doc.uri)"
                  class="block overflow-hidden leading-6 cursor-pointer text-link text-ellipsis whitespace-nowrap"
                  id="ballot-summary-associated-documents-value">{{ doc.datedDesignation }}</a>
              </div>
            </div>
          </div>
          <form class="lg:w-1/2" [formGroup]="ballotSummaryDateForm">
            <div id="div-SRS-Ballot-Start-Date">
              <ng-container *ngIf="isBallotStartDateEditable; else displayStartDate">
                <app-date-picker formControlName="ballotStartDateCtrl" id="SRS-Ballot-Start-Date" name="startDate"
                  label="Start Date" placeholder="Select date" [value]="ballotStartDate" [minDate]="ballotStartMinDate"
                  [maxDate]="ballotStartMaxDate" [isFromBallotSummary]="true">
                </app-date-picker>
              </ng-container>
              <ng-template #displayStartDate>
                <label class="ballot-summary-label" id="SRS-Ballot-Start-Date-label">Start Date</label>
                <p class="ballot-summary-value" id="SRS-Ballot-Start-Date-input" [attr.displayDate]="srsBallotDetail?.ballotStartDate | dateFormat">
                  {{ srsBallotDetail?.ballotStartDate | dateFormat }}
                </p>
              </ng-template>
            </div>
            <div id="div-SRS-Ballot-End-Date">
              <ng-container *ngIf="isBallotEndDateEditable; else displayBallotEndDate">
                <app-date-picker formControlName="ballotEndDateCtrl" id="SRS-Ballot-End-Date" name="endDate"
                  label="End Date" placeholder="Select date" [value]="ballotEndDate" [minDate]="ballotEndMinDate"
                  [isFromBallotSummary]="true">
                </app-date-picker>
              </ng-container>
              <ng-template #displayBallotEndDate>
                <label class="ballot-summary-label" id="SRS-Ballot-End-Date-label">End Date</label>
                <p class="ballot-summary-value" id="SRS-Ballot-End-Date-input" [attr.displayDate]="srsBallotDetail?.ballotEndDate | dateFormat">
                  {{ srsBallotDetail?.ballotEndDate | dateFormat }}
                </p>
              </ng-template>
            </div>
          </form>
        </div>

        <div class="my-4 border-b border-gray-200"></div>


        <form [formGroup]="ballotNoteFormGroup">
          <div class="flex flex-col children:w-full">
            <label for="sr-ballot-note">Notes</label>
            <div *ngIf="!isAuthorized" class="ballot-summary-value">{{ballotNoteCtrl?.value??''}}</div>
            <app-text-area *ngIf="isAuthorized" id="sr-ballot-note" title="Note" formControlName="ballotNoteCtrl" [rows]="6"></app-text-area>
          </div>
        </form>

        <div *ngIf="isVotingActionsVisible">
          <div class="my-4 border-b border-gray-200"></div>

          <div class="mb-4 body-default-bold">My Vote</div>

          <div *ngIf="!hasVoted">No vote placed</div>
          <div *ngIf="hasVoted" class="flex flex-row items-center">
            <span class="mr-2 material-symbols-rounded"
            [ngStyle]="{'color': userVoteOption?.color}">{{userVoteOption?.icon}}</span>
            <span class="body-default-bold">{{userVoteOption?.text}}</span>
            <span>&nbsp;-&nbsp;placed on {{userVoteSubmittedDate}}</span>
          </div>

          <div id="voting-action" class="flex flex-row gap-4 mt-4" *ngIf="!isInternalPublicUser" >

            <button class="w-1/6 btn btn-primary h-[50px]" [disabled]="!isVoteButtonEnable" id="place-vote-Button"
              (click)="openPlaceVoteModal()">{{hasVoted ? 'Change Vote' : 'Place Vote'}}</button>


            <button id="decision-guidance" type="button" *ngIf="!isUserPmOrAbove"
              class="flex items-center justify-between w-[225px] text-xs btn btn-green"
              (click)="openBallotDecisionGuidanceModal()">
              <span class="text-2xl material-symbols-rounded">help</span>Unsure of your decision? Click here for guidance
              &nbsp;&nbsp;
            </button>
          </div>
        </div>
      </div>
    </div>

  </app-card>

  <app-card>
    <div class="flex flex-col w-full">
      <app-srs-eligible-voters
        [srsBallotDetail] = "srsBallotDetail"
        (afterSave)="onBallotSaved($event)" ></app-srs-eligible-voters>
    </div>
  </app-card>
</div>
